import { Accordion } from '@apollo/orbit';
import classnames from 'classnames';
import React, { useCallback } from 'react';

import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

/**
 * Renders the list of error groups.
 *
 * @param children Expecting a list of ErrorGroups.
 * @returns {JSX.Element} A rendered view of the groups.
 */
export function ErrorsByGroup({
  loading,
  children,
}: {
  loading?: boolean;
  children: React.ReactNode;
}) {
  const trackCustomEvent = useTrackCustomEvent();
  const handleChange = useCallback(() => {
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'error_group_accordion_change',
    });
  }, [trackCustomEvent]);

  return (
    <Accordion
      className={classnames({ 'opacity-40': loading })}
      defaultIndex={[0]}
      allowMultiple
      onChange={handleChange}
    >
      {children}
    </Accordion>
  );
}
